import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SavingstransactionService } from "../shared/savingstransaction.service";
import { PrintsavingstransactionlistserviceService } from "../shared/print/printsavingstransactionlistservice.service";

@Component({
  selector: 'app-savingsreceiptslist',
  templateUrl: './savingsreceiptslist.component.html',
  styleUrls: ['./savingsreceiptslist.component.css']
})
export class SavingsreceiptslistComponent implements OnInit {

  private ToReceiptForm: boolean= false;

  displayedColumns: string[] = ['ReceiptNo', 'Customer', 'DepositNo',  'Date',  'Amount', 'ReceiptType', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private savingstransactionService: SavingstransactionService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getSavingsReceiptList();
    this.dataSource.paginator = this.paginator;
  }

  getSavingsReceiptList() {

    this.savingstransactionService.FetchSavingsReceiptsList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  New() {
    this.router.navigate(['/savingsreceipts']);
  }

  Edit(savingsTransaction: any) {
    this.router.navigate(['/savingsreceipts', savingsTransaction.Id]);
  }


  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
}